import { Field, FieldArray, Form, Formik, useFormikContext } from "formik";
import { useEffect, useRef, useState } from "react";
import * as Yup from "yup";
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";
import { FiInfo } from "react-icons/fi";
import { useSelector } from "react-redux";
import { Button, Col, Container, FormGroup, Label, Row } from "reactstrap";
import FileInputField from "../common/Form/FileInput";
import PhoneInputNumber from "../common/Form/MobileInput";
import styles from "./userForm.module.scss"
import InputColor from 'react-input-color';
import FontPicker from "font-picker-react";
import Loader from "../common/Loader/Loader";
import { companyActions } from "../../actions";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { BiEdit, BiLinkExternal } from "react-icons/bi";

import ReactQuill from "react-quill";
import EditorToolbar, { modules, formats, undoChange, redoChange } from "../../components/common/CustomEditor";
import "react-quill/dist/quill.snow.css";
import { AiOutlineCloudUpload, AiOutlineDownload } from "react-icons/ai";
import Avatar from "react-avatar";
import { maxLengthCheck } from "../../helpers";
import { authActions } from "../../actions/auth.actions";
import atsSettingImage from '../../resources/images/atsSettings.png';
import cameraImg from "../../resources/images/camera.svg";


const CompanyForm = (props) => {
    const [edited, setEdited] = useState(false)
    const [selectedFile, setSelectedFile] = useState(null)
    const [preview, setPreview] = useState()
    const [selectedFavIcon, setSelectedFavIcon] = useState(null)
    const [favPreview, setFavPreview] = useState()
    const [selectedBanner, setSelectedBanner] = useState(null)
    const [bannerPreview, setBannerPreview] = useState()
    const companySettings = useSelector((state) => state.company.companySettings)
    const user = useSelector((state) => state.authentication.user);
    const dispatch = useDispatch()
    useEffect(() => {
        setEdited(false)
    }, [props])

    const handleBtnClick = (id) => {
        if (edited) {
            const input = document.getElementById(id);
            if (input) {
                input.click();
            }
        }
    };
    useEffect(() => {
        if (!selectedFile) {
            setPreview(undefined)
            return
        }

        const objectUrl = URL.createObjectURL(selectedFile)
        setPreview(objectUrl)
        // free memory when ever this component is unmounted
        return () => URL.revokeObjectURL(objectUrl)
    }, [selectedFile])

    useEffect(() => {
        if (!selectedFavIcon) {
            setFavPreview(undefined)
            return
        }

        const objectUrl = URL.createObjectURL(selectedFavIcon)
        setFavPreview(objectUrl)
        // free memory when ever this component is unmounted
        return () => URL.revokeObjectURL(objectUrl)
    }, [selectedFavIcon])

    function isFileSizeValid(file, size) {
        if (file) {
            return file?.size <= size * 1024 * 1000;
        } else {
            return true
        }
    }


    useEffect(() => {
        if (!selectedBanner) {
            setBannerPreview(undefined)
            return
        }


        const objectUrl = URL.createObjectURL(selectedBanner)
        setBannerPreview(objectUrl)
        // free memory when ever this component is unmounted
        return () => URL.revokeObjectURL(objectUrl)
    }, [selectedBanner])

    const SUPPORTED_FORMATS = ["image/jpeg", "image/jpg", "image/png"];
    return (
        <div>
            {companySettings ?
                <Formik
                    initialValues={{
                        name: companySettings?.name ? companySettings?.name : "",
                        logo: "",
                        favicon: "",
                        domain: companySettings?.domain ? companySettings?.domain : localStorage.getItem('domain'),
                        address: companySettings?.address,
                        gstDetails: companySettings?.gstDetails,
                        buttonColor: companySettings?.buttonColor,
                        fontColor: companySettings?.fontColor ? companySettings?.fontColor : '#FFFFFF',
                        fontWeight: companySettings?.fontWeight ? companySettings?.fontWeight : 400,
                        headerColor: companySettings?.headerColor,
                        fontType: companySettings?.fontType ? companySettings?.fontType : "Open Sans",
                        navBars: companySettings?.navBars && companySettings?.navBars.length > 0 ?
                            companySettings?.navBars :
                            [{
                                text: "",
                                link: ""
                            }],
                        bannerImage: "",
                        bannerTitle: companySettings?.banner?.bannerTitle,
                        bannerDetail: companySettings?.banner?.bannerDetail,
                        bodyTitle: companySettings?.body?.bodyTitle,
                        bodyDetail: companySettings?.body?.bodyDetail,
                        openingTitle: companySettings?.body?.openingTitle,
                        pagetitle: companySettings?.pagetitle,
                        meta: companySettings?.meta
                    }}
                    onSubmit={values => {
                        if (values) {

                            dispatch(companyActions.updateCompanySettings(values)).then(res => {
                                if (res) {
                                    setEdited(false)
                                    localStorage.setItem("domain", res?.domain);
                                    dispatch(authActions.getProfile())
                                }
                            })

                        }
                    }}
                    validationSchema={Yup.object().shape({
                        name: Yup.string().required("Company name is required"),
                        logo: Yup
                            .mixed()
                            .test(
                                "format",
                                "Only the following formats are accepted: .jpeg, .jpg and .png",
                                (value) => !value || (value && SUPPORTED_FORMATS.includes(value.type))
                            )
                            .test(
                                'fileSize',
                                'File size cannot exceed 1MB',
                                (value) => isFileSizeValid(value, 2)
                            ),
                        bannerImage: Yup
                            .mixed()
                            .test(
                                "format",
                                "Only the following formats are accepted: .jpeg, .jpg and .png",
                                (value) => !value || (value && SUPPORTED_FORMATS.includes(value.type))
                            )
                            .test(
                                'fileSize',
                                'File size cannot exceed 5MB',
                                (value) => isFileSizeValid(value, 5)
                            ),
                        favicon: Yup
                            .mixed()
                            .test(
                                "format",
                                "Only the following formats are accepted: .ico and .png",
                                (value) => !value || (value && ["image/vnd.microsoft.icon", "image/png"].includes(value.type))
                            ),
                        navBars: Yup.array().max(10, "Max 10 navigation is required")
                    })}
                    render={({ values, touched,
                        errors, setFieldValue, resetForm }) => (
                        <Form encType="multipart/form-data">
                            <div className={`${styles.userForm}`}>
                                <Container className={styles.containerPart}>
                                    <div className={styles.cInfoPart}>
                                        <span className={styles.headingText}>Company Info   {companySettings?.name ?
                                            <a className="ms-3" href={`https://${localStorage.getItem('domain') ? localStorage.getItem('domain') : user?.domain}/careers`} target="_blank"><BiLinkExternal /></a> : ""
                                        }</span>

                                        <div className={styles.buttonDt}>
                                            {edited ?
                                                "" : <div className={styles.editButton}>
                                                    <Button className={`btn btn-default ${styles.buttonPart}`} onClick={() => setEdited(true)}>Edit <BiEdit /></Button>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <Row>
                                        <Col md={6}>
                                            <FormGroup className="form-group">
                                                <Label className={styles.formLabel}>Company Name</Label>
                                                <Field
                                                    className="form-control"
                                                    name="name"
                                                    disabled={edited && user?.userRole == 1 ? false : true}
                                                    autoComplete="off"
                                                    maxlength="200"
                                                />
                                                {errors.name || touched.name ? (
                                                    <div className={styles.formError}>{errors.name}</div>
                                                ) : null}
                                            </FormGroup>
                                            <FormGroup className="form-group">
                                                <Label className={styles.formLabel}>Company Domain</Label>
                                                <Field
                                                    className="form-control"
                                                    name="domain"
                                                    disabled={edited && user?.userRole == 1 ? false : true}
                                                    autoComplete="off"
                                                    maxlength="200"
                                                />
                                            </FormGroup>
                                            <FormGroup className="form-group">
                                                <Label className={styles.formLabel}>Company GST Details</Label>
                                                <Field
                                                    className="form-control"
                                                    name="gstDetails"
                                                    autoComplete="off"
                                                    maxlength="200"
                                                    disabled={edited && user?.userRole == 1 ? false : true}
                                                />
                                            </FormGroup>
                                            <FormGroup className="form-group">
                                                <Label className={styles.formLabel}>Company Address</Label>
                                                <Field
                                                    as="textarea"
                                                    className="form-control"
                                                    name="address"
                                                    autoComplete="off"
                                                    maxlength="200"
                                                    disabled={edited && user?.userRole == 1 ? false : true}
                                                />
                                            </FormGroup>
                                            <Row>
                                                <Col md={6}>
                                                    <FormGroup className="form-group">
                                                        <Label className={styles.formLabel}>
                                                            Company Logo{" "}
                                                            <FiInfo
                                                                className="infoIcon"
                                                                title="Only jpg, jpeg and png file is allowed"
                                                            />

                                                        </Label>

                                                        <div className={`imageUploadPart + ${edited ? 'cursorPointerOnEdit' : ''}`} onClick={() => handleBtnClick("logo")}>
                                                            {companySettings && companySettings?.logo?.url && (!edited || selectedFile === null) ?
                                                                <div >
                                                                    <div className="imageUploadPartInner">
                                                                        <img className={styles.profileImage} src={companySettings?.logo?.url} />
                                                                        <div className="cameraImageContainer">
                                                                            {
                                                                                edited && <img className="cameraImage" src={cameraImg} alt="camera" />
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                :
                                                                selectedFile ?
                                                                    <div className="imageUploadPartInner">
                                                                        <img className={styles.profileImage} src={preview} />
                                                                        <div className="cameraImageContainer">
                                                                            {
                                                                                edited && <img className="cameraImage" src={cameraImg} alt="camera" />
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                    :
                                                                    <div className="imageUploadPartInner">
                                                                        <div className="cloudIconPart">
                                                                            <AiOutlineCloudUpload styles={{ fontSize: 16 }} />
                                                                        </div>
                                                                    </div>
                                                            }
                                                        </div>

                                                        <input
                                                            type="file"
                                                            id="logo"
                                                            name="logo"
                                                            onChange={(e) => {
                                                                if (!e.target.files || e.target.files.length === 0) {
                                                                    setSelectedFile(undefined)
                                                                    return
                                                                }
                                                                setFieldValue('logo', e.target.files[0]);
                                                                setSelectedFile(e.target.files[0])
                                                            }}
                                                            style={{ display: "none" }}
                                                        />


                                                        {errors.logo && touched.logo ? (
                                                            <div className={styles.formError}>{errors.logo}</div>
                                                        ) : null}

                                                    </FormGroup>
                                                </Col>
                                                <Col md={6}>
                                                    <FormGroup className="form-group">
                                                        <Label className={styles.formLabel}>
                                                            Company Favicon{" "}
                                                            <FiInfo
                                                                className="infoIcon"
                                                                title="Only .ico and .png file is allowed"
                                                            />

                                                        </Label>

                                                        <div className={`imageUploadPart favMainPart + ${edited ? 'cursorPointerOnEdit' : ''}`} onClick={() => handleBtnClick("favicon")}>
                                                            {companySettings && companySettings?.favicon?.url && (!edited || selectedFavIcon === null) ?
                                                                <div>
                                                                    <div className="imageUploadFav">

                                                                        <img className="favIconPre" src={companySettings?.favicon?.url} />
                                                                        <div className="cameraImageContainer">
                                                                            {
                                                                                edited && <img className="cameraImage" src={cameraImg} alt="camera" />
                                                                            }
                                                                        </div>
                                                                    </div>

                                                                </div> :
                                                                selectedFavIcon ?

                                                                    <div className="imageUploadFav">
                                                                        <img className="favIconPre" src={favPreview} />
                                                                        <div className="cameraImageContainer">
                                                                            {
                                                                                edited && <img className="cameraImage" src={cameraImg} alt="camera" />
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                    :
                                                                    <div className="imageUploadPartInner">
                                                                        <div className="cloudIconPart">
                                                                            <AiOutlineCloudUpload styles={{ fontSize: 16 }} />
                                                                        </div>
                                                                    </div>
                                                            }
                                                        </div>
                                                        <input
                                                            type="file"
                                                            id="favicon"
                                                            name="favicon"
                                                            onChange={(e) => {
                                                                if (!e.target.files || e.target.files.length === 0) {
                                                                    setSelectedFavIcon(undefined)
                                                                    return
                                                                }

                                                                setFieldValue('favicon', e.target.files[0]);
                                                                setSelectedFavIcon(e.target.files[0])
                                                            }}
                                                            style={{ display: "none" }}
                                                        />

                                                        {errors.favicon && touched.favicon ? (
                                                            <div className={styles.formError}>{errors.favicon}</div>
                                                        ) : null}

                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </Col>

                                        <Col md={6}>
                                            <Row >
                                                <img src={atsSettingImage} alt="" />
                                            </Row>
                                        </Col>
                                    </Row>
                                    <hr />
                                    <div className="tab-part">Careers page settings
                                    </div>
                                    <Row>
                                        <Col md={12}>
                                            <Label>Navigation</Label>
                                            <FieldArray
                                                name="navBars"
                                                render={arrayHelpers => (
                                                    values.navBars && values.navBars.length > 0 ? (
                                                        values.navBars.map((val, index) => (
                                                            <div>
                                                                <FormGroup className="form-group">
                                                                    <Row>
                                                                        <Col md={6}>
                                                                            <Field
                                                                                type="text"
                                                                                className="form-control"
                                                                                name={`navBars.${index}.text`}
                                                                                placeholder="Label"
                                                                                required
                                                                                onKeyPress={(event) => {
                                                                                    // maxLengthCheck(event);
                                                                                }}
                                                                                maxlength="15"
                                                                                disabled={edited ? false : true}
                                                                            />
                                                                        </Col>
                                                                        <Col md={5}>
                                                                            <Field
                                                                                type="text"
                                                                                className="form-control"
                                                                                name={`navBars.${index}.link`}
                                                                                placeholder="Link"
                                                                                required
                                                                                maxlength="200"
                                                                                disabled={edited ? false : true}
                                                                            />
                                                                        </Col>
                                                                        <Col md={1}>
                                                                            {values.navBars.length !== index + 1 ? (
                                                                                <div
                                                                                    className="button remove remove-button-part"
                                                                                    onClick={() => arrayHelpers?.form?.values?.navBars?.length !== 1 && edited && arrayHelpers.remove(index)}
                                                                                >
                                                                                    {
                                                                                        edited ? (<span>x</span>) : ('')
                                                                                    }

                                                                                </div>
                                                                            ) : (
                                                                                <>
                                                                                    <div className="closeButtonGroup">
                                                                                        <div
                                                                                            className="button remove remove-button-part"
                                                                                            onClick={() => {
                                                                                                if (arrayHelpers?.form?.values?.navBars?.length !== 1) {
                                                                                                    edited && arrayHelpers.remove(index)
                                                                                                }
                                                                                            }}

                                                                                        >
                                                                                            {
                                                                                                edited ? (<>
                                                                                                    {
                                                                                                        arrayHelpers?.form?.values?.navBars?.length !== 1 ? (<><span >x</span></>) : (<></>)
                                                                                                    }
                                                                                                </>) : ('')
                                                                                            }


                                                                                        </div>
                                                                                        {
                                                                                            edited ? (<>
                                                                                                {values.navBars.length < 10 ?
                                                                                                    <button
                                                                                                        className={`button add add-button-part`}
                                                                                                        type="button"
                                                                                                        disabled={edited ? false : true}
                                                                                                        onClick={() => arrayHelpers.insert(index + 1, {
                                                                                                            text: "",
                                                                                                            link: ""
                                                                                                        })}
                                                                                                    >
                                                                                                        <span>+</span>
                                                                                                    </button> : ""
                                                                                                }
                                                                                            </>) : ('')
                                                                                        }


                                                                                    </div>
                                                                                </>
                                                                            )}
                                                                        </Col>
                                                                    </Row>
                                                                </FormGroup>
                                                            </div>

                                                        ))
                                                    ) : ""

                                                )} />
                                            {errors.navBars || touched.navBars ? (
                                                <div className={styles.formError}>{errors.navBars}</div>
                                            ) : null}
                                        </Col>
                                        <Col md={2}><Label className={styles.formLabel}>Color Theme :</Label></Col>
                                        <Col md={2} className="p-0">

                                            <FormGroup className="form-group">
                                                <input
                                                    type="color"
                                                    class="form-control form-control-color"
                                                    id="fontColor"
                                                    value={values?.fontColor}
                                                    disabled={edited ? false : true}
                                                    onChange={(color) => {
                                                        if (color?.target?.value) {
                                                            setFieldValue("fontColor", color?.target?.value)
                                                        }
                                                    }}
                                                />
                                            </FormGroup>

                                        </Col>

                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <FormGroup className="form-group">
                                                <Label className={styles.formLabel}>Banner Title</Label>
                                                <Field
                                                    as="textarea"
                                                    name="bannerTitle"
                                                    id="bannerTitle"
                                                    maxlength="90"
                                                    rows="4"
                                                    className="form-control"
                                                    disabled={edited ? false : true}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={6}>
                                            <FormGroup className="form-group">
                                                <Label className={styles.formLabel}>Banner Details</Label>
                                                <Field
                                                    as="textarea"
                                                    name="bannerDetail"
                                                    id="bannerDetail"
                                                    maxlength="250"
                                                    rows="4"
                                                    className="form-control"
                                                    disabled={edited ? false : true}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={6}>
                                            <FormGroup className="form-group">
                                                <Label className={styles.formLabel}>Body Title</Label>
                                                <Field
                                                    as="textarea"
                                                    name="bodyTitle"
                                                    id="bodyTitle"
                                                    maxlength="90"
                                                    rows="4"
                                                    className="form-control"
                                                    disabled={edited ? false : true}
                                                />

                                            </FormGroup>
                                        </Col>
                                        <Col md={6}>
                                            <FormGroup className="form-group">
                                                <Label className={styles.formLabel}>Body Details</Label>
                                                <Field
                                                    as="textarea"
                                                    name="bodyDetail"
                                                    id="bodyDetail"
                                                    maxlength="500"
                                                    rows="4"
                                                    className="form-control"
                                                    disabled={edited ? false : true}
                                                />

                                            </FormGroup>
                                        </Col>
                                        <Col md={6}>
                                            <FormGroup className="form-group">
                                                <Label className={styles.formLabel}>Opening Title</Label>
                                                <Field
                                                    as="textarea"
                                                    name="openingTitle"
                                                    id="openingTitle"
                                                    maxlength="30"
                                                    rows="5"
                                                    className="form-control"
                                                    disabled={edited ? false : true}
                                                />

                                            </FormGroup>
                                        </Col>
                                        <Col md={6}>
                                            <FormGroup className="form-group">
                                                <Label className={styles.formLabel}>
                                                    Banner Image{" "}
                                                    <FiInfo
                                                        className="bannerImage"
                                                        title="Only jpg, jpeg and png file is allowed"
                                                    />
                                                </Label>
                                                <div className={`imageUploadBanner + ${edited ? 'cursorPointerOnEdit' : ''}`} onClick={() => handleBtnClick("bannerImage")}>
                                                    {companySettings && companySettings?.banner?.bannerImage?.url && (!edited || selectedBanner === null) ?
                                                        <div>
                                                            <div className="imageUploadPartBanner">
                                                                <img className="bannerPre" src={companySettings?.banner?.bannerImage?.url} />

                                                                <div className="cameraImageContainer">
                                                                    {
                                                                        edited && <img className="cameraImage" src={cameraImg} alt="camera" />
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div> :
                                                        selectedBanner ?
                                                            <div className="imageUploadPartBanner">
                                                                <img className="bannerPre" src={bannerPreview} />
                                                                <div className="cameraImageContainer">
                                                                    {
                                                                        edited && <img className="cameraImage" src={cameraImg} alt="camera" />
                                                                    }
                                                                </div>
                                                            </div>
                                                            :
                                                            <div className="imageUploadPartBanner">
                                                                <div className="cloudIconPart">
                                                                    <AiOutlineCloudUpload styles={{ fontSize: 16 }} />
                                                                </div>
                                                            </div>
                                                    }
                                                </div>
                                                <input
                                                    type="file"
                                                    id="bannerImage"
                                                    name="bannerImage"
                                                    onChange={(e) => {
                                                        if (!e.target.files || e.target.files.length === 0) {
                                                            setSelectedBanner(undefined)
                                                            return
                                                        }

                                                        setFieldValue('bannerImage', e.target.files[0]);
                                                        setSelectedBanner(e.target.files[0])
                                                    }}
                                                    style={{ display: "none" }}
                                                />
                                                {errors.bannerImage && touched.bannerImage ? (
                                                    <div className={styles.formError}>{errors.bannerImage}</div>
                                                ) : null}

                                            </FormGroup>
                                        </Col>
                                        <Col md={6}>
                                            <FormGroup className="form-group">
                                                <Label className={styles.formLabel}>Page Title</Label>
                                                <Field
                                                    className="form-control"
                                                    name="pagetitle"
                                                    disabled={edited ? false : true}
                                                    autoComplete="off"
                                                    maxlength="30"
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={6}>
                                            <FormGroup className="form-group">
                                                <Label className={styles.formLabel}>Meta</Label>
                                                <Field
                                                    className="form-control"
                                                    name="meta"
                                                    disabled={edited ? false : true}
                                                    autoComplete="off"
                                                    maxlength="500"
                                                    as="textarea"
                                                />
                                            </FormGroup>
                                        </Col>

                                    </Row>
                                    {edited ?
                                        <div className={styles.buttonVal}>
                                            <Button type="submit" className={styles.brandButton}>
                                                Save
                                            </Button>
                                            <Button type="reset" onClick={() => {
                                                resetForm()
                                                setEdited(false)
                                            }} className={`${styles.brandButton} mx-2`}>
                                                Cancel
                                            </Button>
                                        </div> : ""
                                    }

                                </Container>
                            </div>
                        </Form>
                    )}
                /> : <Loader color={"#5382ba"} />
            }

        </div>
    )
};






export default CompanyForm;